interface LogoProps {
  className?: string;
  iconSize?: number;
  style?: React.CSSProperties;
}

export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="DebtBridge logo"
      className={className}
      style={{ height: size, width: "auto", display: "block" }}
    />
  );
}

export function Logo({ className, iconSize = 28, style }: LogoProps) {
  return (
    <div style={{ display: "flex", alignItems: "center", ...style }} className={className}>
      <img
        src="/logo.png"
        alt="DebtBridge"
        style={{ height: iconSize, width: "auto", display: "block" }}
      />
    </div>
  );
}
